import { SectionLayout, WidgetTypes } from '../../types';
import WidgetList from '../widgets/WidgetList';

interface Props {
  pageId: string;
  widgets: WidgetTypes[];
  sectionId: string;
  columnIndex: number;
  numberOfColumns: number;
  contentSpacing: number;
  sectionLayout: SectionLayout;
}

const ColumnPreview = ({
  pageId,
  widgets,
  sectionId,
  columnIndex,
  contentSpacing,
  numberOfColumns,
  sectionLayout,
}: Props) => (
  <WidgetList
    contentSpacing={contentSpacing}
    sectionLayout={sectionLayout}
    pageId={pageId}
    widgets={widgets}
    sectionId={sectionId}
    columnIndex={columnIndex}
    numberOfColumns={numberOfColumns}
  />
);

export default ColumnPreview;
